// extracted by mini-css-extract-plugin
export var container = "layout-module--container--eLBMS";
export var spikedheadline = "layout-module--spikedheadline--Ooq+W";